export default __webpack_public_path__ + "static/media/undraw_color_palette_yamk.00649bf0.png";